import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=00573152"
import script from "./RegisterCard.vue?vue&type=script&lang=js"
export * from "./RegisterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports